export enum BusinessLevels {
    BRANCH = 'BRANCH',
    PAN = 'PAN',
    GSTIN = 'GSTIN',
  }
  export type BusinessDetails = {
    id: string;
    entityName?: string;
    name?: string;
    __children: BusinessDetails[];
    parentOrgUnitId?: string;
    childIds: string[];
    canAccess?: boolean;
    identifier?: string;
    level: string;
    metadata?: object;
  };